export const newBookingOverlayType = {
  pickUpAddress: 'pickUpAddress',
  dropOffAddress: 'dropOffAddress',
  serviceConfiguration: 'serviceConfiguration',
  offerConfiguration: 'offerConfiguration',
  offerTermCondition: 'offerTermCondition',
  vehicleType: 'vehicleType',
  addOn: 'addOn',
  deliveryGuarantee: 'deliveryGuarantee',
  deliveryGuaranteeTnc: 'deliveryGuaranteeTnc',
};

export default {};
